// Importing services for notifications
import { notifications } from "@/services/index";

// List of pages where notifications should not be displayed
const notLoginPage = [
    "Login", "ForgotPassword", "MobileApp", "Captcha", "ForgotPasswordResend", "ResetPassword",
    "Terms", "PrivacyPolicy",
    "Error401", "Error422", "Error498", "Error500", "Error404"
];

export default {
    data() {
        return {
            notLoginPage: notLoginPage,
            timeIntervalID: null,
            timeIntervalCompletion: null,
            timeInterval: 5000, // Time interval for checking notifications (in milliseconds)
        };
    },
    watch: {
        // Watching for route changes to determine whether to start or stop notifications
        $route(to, from) {
            if (this.notLoginPage.includes(to.name)) {
                this.stopNotificationCompletion();
            } else {
                this.startNotificationCompletion();
            }
        },
    },
    created() {
        // On component creation, stop notification completion
        this.stopNotificationCompletion();
    },
    // mounted() { },
    methods: {
        // Function to start the interval for checking completion notifications
        // startRequestIntervalCompletion() {
        //     this.timeIntervalCompletion = setInterval(() => {
        //         this.getProductCompletion();
        //     }, this.timeInterval);
        // },

        // Function to fetch product completion notifications
        async getProductCompletion() {
            try {
                const res = await notifications.getNotificationCompletion();
                let { notify, message } = res.data;

                // Display success notification and initiate further actions if notification is received
                if (notify) {
                    this.$store.commit("alert/successCmp", message);
                    // this.$store.commit("alert/setAutoCloseCmp", true);
                    // clearInterval(this.timeIntervalCompletion);
                    // this.stopRequestInterval(() => {
                    //     this.getCheckProcessing();
                    // });
                } else {
                    // If no notification, restart the completion notification interval
                    // clearInterval(this.timeIntervalID);
                    // if (!this.timeIntervalCompletion) {
                    //     this.startRequestIntervalCompletion();
                    // }
                }
            } catch (error) {
                console.warn(error);
                this.stopRequestInterval();
                // this.stopRequestInterval(() => {
                //     this.getCheckProcessing();
                // });
            }
        },

        // Function to check if processing is ongoing
        // async getCheckProcessing() {
        //     try {
        //         const res = await notifications.getCheckProcessing();

        //         let { value } = res.data;

        //         // If processing is ongoing, restart the regular notification interval
        //         if (value) {
        //             this.startRequestInterval();
        //         } else {
        //             // If not, keep checking until processing begins
        //             this.stopRequestInterval();
        //             setTimeout(() => {
        //                 this.getCheckProcessing();
        //             }, this.timeInterval);
        //         }
        //     } catch (error) {
        //         console.warn(error);
        //         this.stopRequestInterval(() => {
        //             this.getCheckProcessing();
        //         });
        //     }
        // },

        // Function to stop the interval for making requests
        stopRequestInterval(callback = undefined) {
            if (!this.timeIntervalID) return;
            clearInterval(this.timeIntervalID);
            clearInterval(this.timeIntervalCompletion);
            this.timeIntervalID = null;
            this.timeIntervalCompletion = null;

            // if (callback) {
            //     // Execute callback after clearing the interval
            //     setTimeout(() => {
            //         this.$store.commit("alert/clearCmp");
            //         this.$store.commit("alert/setAutoCloseCmp", false);
            //         callback();
            //     }, this.timeInterval);
            // } else {
            //     this.$store.commit("alert/clearCmp");
            //     this.$store.commit("alert/setAutoCloseCmp", false);
            // }
        },

        // Function to start the interval for making requests
        startRequestInterval() {
            this.timeIntervalID = setInterval(() => {
                this.getProductCompletion();
            }, this.timeInterval);
        },

        // Function to stop the display of completion notifications
        stopNotificationCompletion() {
            if (localStorage.getItem('is_notify_completion')) {
                localStorage.removeItem('is_notify_completion');
                this.stopRequestInterval();
            }
        },

        // Function to start the display of completion notifications
        startNotificationCompletion() {
            if (localStorage.getItem('is_notify_completion')) return;
            localStorage.setItem('is_notify_completion', '1');

            // Clear existing notifications and initiate the check for processing
            this.stopRequestInterval();
            setTimeout(() => {
                // this.getCheckProcessing();
                this.startRequestInterval();
            }, 750);
        },
    },
};
